export default __webpack_public_path__ + "static/media/RBMScreenImg.99431fc9.jpg";